import React from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { IconButton } from '@mui/material';

import { ITableSortProps } from 'src/components/common/types/tableTypes';

export const TableSort = <T,>({
	column,
	queryState,
	onQueryChange,
}: ITableSortProps<T>): React.JSX.Element | null => {
	const isActive = queryState.sortBy === column.key;
	const isAsc = queryState.sortOrder === 'asc';

	const handleSortClick = () => {
		let nextOrder: 'asc' | 'desc';

		if (!isActive) {
			nextOrder = column.defaultSortOrder ?? 'asc';
		} else {
			nextOrder = isAsc ? 'desc' : 'asc';
		}

		onQueryChange({
			sortBy: column.key as string,
			sortOrder: nextOrder,
			page: 0,
		});
	};

	return (
		<>
			{isActive ? (
				<IconButton onClick={handleSortClick}>
					{isAsc ? (
						<ArrowDownwardIcon fontSize='small' />
					) : (
						<ArrowUpwardIcon fontSize='small' />
					)}
				</IconButton>
			) : (
				<IconButton onClick={handleSortClick}>
					<ArrowUpwardIcon fontSize='small' color='disabled' />
				</IconButton>
			)}
		</>
	);
};
